/* global Excel */
export async function insertTextToFile(journalistId: string) {
  return await Excel.run(async (context) => {
    await context.sync();
    const sheet = context.workbook.worksheets.getItem("Robocza lista gości");
    sheet.load("protection/protected");
    const table = sheet.tables.getItem("Lista");

    await context.sync();
    sheet.protection.unprotect();
    table.rows.add(
      null,
      [
        [
          journalistId,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      ],
      true
    );

    sheet.protection.protect({
      allowAutoFilter: true,
      allowDeleteColumns: false,
      allowDeleteRows: true,
      allowFormatRows: true,
      allowInsertRows: true,
      allowFormatColumns: true,
      allowFormatCells: true,
      allowInsertColumns: false,
      allowSort: true,
      allowInsertHyperlinks: false,
      allowPivotTables: false,
    });
    await context.sync();
  });
}
